export enum OrderType {
    Simple = `simple`,
    Consolidated = `consolidated`,
    Auto = `auto`,
}
